import React from "react";
import Heading from "./UI/Heading";
import PricingPic from "../assets/pricing-pic.png";

const Pricing = () => {
  return (
    <section className="flex flex-col items-center mt-64 text-center px-10">
      <Heading text="Pricing" />
      <img src={PricingPic} className="mt-24 w-44" alt="" />
      <h1 className="text-neon text-lg mt-10 xl:text-2xl tracking-widest">Pricing: 0.1ETH/month AlWAYS in stock.</h1>;
    </section>
  );
};

export default Pricing;
